//-*-mode: rjsx -*-
// REACT
import React, { Component } from "react"
import PropTypes from "prop-types"

// MUI
import {  withStyles } from "@material-ui/core/styles"

// D3
import * as d3 from "d3" 

import * as _ from "lodash"

// LOGGING SETUP
import appConfig from "./../../../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<DashBarChart>")


const styles = theme => ({
//    sheet_old: {
//        margin: 0,
//        padding: 0,
//        borderWidth: "0.3em",
//        borderStyle: "dotted",
//        borderColor: "grey",
//    },
    chartDiv: {
        position: "relative",
        width: "100%", // this is working
        height: "100%",
        margin: 0,
        padding: 0,
        // borderWidth: "4px", // we set that as a prop
        borderStyle: "dotted",
        borderColor: "grey",
        // backgroundColor: "#f7f6f6"
        backgroundColor: "white", // color inside the
        "& :hover": {
            // backgroundColor: "black" // color inside the
        }
    },
    chartSvg: {
        margin: 0,
        padding: 0,

    },
    
    circleExample: {
        r: 50,
        cx: 50,
        cy: 50
    },

    removed: {
        display: "none"
    },

    xAxis: {
        '& path': {
            display: "none"
        }
    },

    yAxis: {
        '& path': {
            display: "none"
        }
    },

    bar1: {
        fill: "#438CFF"
    },
    
    bar2: {
        fill: "#006EDD",
        opacity: 0.5
    },

    marker1: {
    },

    listener: {
        fill: "transparent",
    },

    //
    //  tooltip stuff
    //
    tooltip: {
        position: "absolute", // will be absolute to the "wrapper" and parallel to the sheet
        display: "none", // do not display at first
        //        top: "-12px",
        left: "0",
        padding: "0.6em 1em",
        background: "#fff",
        //   background: "red",
        boxShadow: "0 6px 8px rgba(52, 73, 94, .2), 0 1px 1px rgba(52, 73, 94, 0.1)",
        transition: "all 0.2s ease-out",
        pointerEvents: "none",
    },

    tooltipAnchor_old: {
//        content: '',
        position: "relative",
        bottom: "-9px",
        left: "50%",
        width: "12px",
        height: "12px",
        background: "white",
        border: "1px solid #ddd",
        borderTopColor: "transparent",
        borderLeftColor: "transparent",
        transform: "translate(-50%, 50%) rotate(45deg)",
        transformOrigin: "center center",
        zIndex: 10
    },

    tooltipAnchor: {
        position: "absolute",
        width: "12px",
        height: "12px",
        bottom: "-0",
        left: "50%",
        transform: "translate(-50%, 50%) rotate(45deg)",
        background: "white",
        border: "1px solid #ddd",
        borderTopColor: "transparent",
        borderLeftColor: "transparent",
        // backgroundColor: "red",
        // transformOrigin: "center center", // we don't need this
    },

//    killTransition: {
//        transition: "sdf!importantxo"
//    }

    killTransition: {
        // display is not really a transition, but
        // by specifying it here, we're killing the "all
        // in the externalTooltip that has the transition
        // for the cases outside this
        transition: "display 0.2s ease-out !important"
    }
    
})

class DashBarChart extends Component {

    static defaultProps = {
        showBar1: true,
        showBar2: true,
        showBar3: false,
        bar1Spacing: 10,
        bar2Spacing: 2,
        showXAxis: false,
        showYAxis: false,
        borderWidth: 0,
        paddingTop: 5,
        paddingRight: 5,
        paddingBottom: 5,
        paddingLeft: 5,
        paddingInner: 0,// 0.1
    }

    // NEXT: padding top to be complete 0 with a full width bar
    // with no spacing


    constructor(props) {
        super(props)

        const { dataset, superset,
                // eslint-disable-next-line                
                subset } = this.props
        this.dataset = dataset
        this.superset = superset
        
        log.trace("constructor(): dataset =", this.dataset)

        // we don't need to have those to be part of the state
        // cause it's chart-only
        this.showCircle = true

        this.state = {
            minX: 0
        }
        
    }

    handleChartClick = () => {
        // eslint-disable-next-line
        const { classes } = this.props

        log.trace("DashBarChar: handleChartClick(): this =", this)

        //        d3.select(this.refs.chartSvg).select(`#circle-1`)
        //        .classed(classes.removed, !this.showCircle)
        //        this.showCircle = !this.showCircle
        // this.setState({minX: this.state.minX + 1})
    }

    calcDims = () => {

        const { bar1Spacing,
                bar2Spacing,
                borderWidth,
                paddingTop, paddingRight, paddingBottom, paddingLeft, paddingInner
              } = this.props

        log.trace("DashBarChar: calcDims(): borderWidth =", borderWidth)
        
        let paintMargin = {top: paddingTop, right: paddingRight, bottom: paddingBottom, left: paddingLeft, inner: paddingInner}
//        const paintMargin = {top: paddingTop, right: paddingRight, bottom: paddingBottom, left: paddingLeft}
        //let margin = {top: 0, right: 0, bottom: 0, left: 0}

        // x-axis shows up in the bottom margin
        // top: works ok, just a bit of maring, but good for now
        // right: ok
        // bottom: the x-axis shows up in the bottom margin -ok
        // left: y-axis shows up on the left margin - ok
        // let margin = {top: 20,  right: 20, bottom: 30, left: 30}
        
        const chartDiv = d3.select(this.refs.chartDiv)
        const chartWidth = chartDiv.node().getBoundingClientRect().width
        const chartHeight = chartDiv.node().getBoundingClientRect().height
        const paintWidth = +chartWidth - paintMargin.left - paintMargin.right
        const paintHeight = +chartHeight - paintMargin.top - paintMargin.bottom

        this.dims = {
            chart: { // total chart div dimensions
                width: chartWidth,
                height: chartHeight
            },
            svg: { // svg tag size and other attributes
                width: chartWidth - borderWidth * 2,
                height: chartHeight - borderWidth * 2,
                viewBox: `0 0 ${chartWidth - borderWidth}px ${chartHeight - borderWidth}px`, // chartSvg
            },
            paint: { // actual paint sizes, this is what the transforms are made on
                width: paintWidth,
                height: paintHeight,
                margin: paintMargin
            },
            bar1: {
                spacing: bar1Spacing
            },
            bar2: {
                spacing: bar2Spacing
            },
            marker1: {
                width: 10
            },
            border: {
                width: borderWidth
            },
        }

        log.trace("DashBarChar: calcDims(): bar1Spacing =", bar1Spacing)
        log.trace("DashBarChar: calcDims(): this.dims =", this.dims)
        
    }


    drawChart = () => {

        // eslint-disable-next-line
        const { classes, showXAxis, showYAxis, showBar1, showBar2, showBar3 } = this.props

        log.trace("drawChart(): this.dataset =", this.dataset)


        this.calcDims()

        const chart = d3.select(this.refs.chartDiv)
        chart.style("border-width", `${this.dims.border.width}px`)
        

        log.trace("drawChart(): this.dims.paint.width =", this.dims.paint.width)
        
        const x = d3.scaleLinear().rangeRound([0, this.dims.paint.width]);
//        x.domain([0,1000])

//        log.trace("drawChart(): x(0) =", x(0))
//        log.trace("drawChart(): x(1) =", x(200))

        
        //        const y = d3.scaleBand().rangeRound([0,this.dims.paint.height]).padding(0.1);
        const y = d3.scaleBand().rangeRound([0,this.dims.paint.height]).padding(this.dims.paint.margin.inner)

        // this domain and scale are chart based, not paint based ast for regular bars
        const yListener = d3.scaleBand().rangeRound([0,this.dims.chart.height])
        const svg = d3.select(this.refs.chartSvg)
        
        svg
            .style("width", this.dims.svg.width)
            .style("height", this.dims.svg.height)
        
        const g = svg.append("g")
              .attr("transform", `translate(${this.dims.paint.margin.left},${this.dims.paint.margin.top})`)

        if(this.superset) {
            log.trace("DashBarChar: drawChart(): HAS superset")
        } else {
            log.trace("DashBarChar: drawChart(): NO superset")
        }
        
        if(this.superset) {
            x.domain([0,
                      // we can not have 0 here, max has to be at least 1
                      // for datasets with all 0's, be low will return "at least" 1
                      _.max([1,d3.max(this.superset, d => d.col1)]) // 
                     ])
        } else {
            x.domain([0, _.max(1,d3.max(this.dataset, d => d.col1))
                     ])
        }
        
        y.domain(this.dataset.map( d => {
            return d.name;
        }))

        yListener.domain(this.dataset.map( d => {
            return d.name;
        }))

        
        log.trace("DashBarChar: constructor(): this.dims.svgHeight =", this.dims.svgHeight)

         
        //https://github.com/d3/d3-axis#axis_tickValues
        //https://stackoverflow.com/questions/13100314/change-the-ticks-on-x-axis#13102118
        if(showXAxis) {
            g.append("g")
                .attr("class", classes.xAxis)
                .attr("transform", `translate(0,${this.dims.paint.height})`) // this transforms it vertical
                .call(d3.axisBottom(x).ticks(4))
            //.call(d3.axisBottom(x).tickValues(d3.range(0,10000,450))) // nice specific range starting with 0,range 450
        }

        if(showYAxis) {
            g.append("g")
                .attr("class", classes.yAxis)
                .call(d3.axisLeft(y))
        }

        if(showBar1) {
            // bar1 = col1, dark blue
            g.selectAll(".bar1")
                .data(this.dataset)
                .enter().append("rect")
                .attr("class", classes.bar1)
                .attr("x", 0)
                .attr("y", d => y(d.name) + this.dims.bar1.spacing/2)
                .attr("width", d => {
                    const widthValue = x(d.col1)
                    log.trace("drawChart(): d =",d)
                    log.trace("drawChart(): widthValue =", widthValue) // debug here why so high
                    return widthValue
                }
                     ) 
                .attr("height", y.bandwidth() - this.dims.bar1.spacing);
        }

        if(showBar2) {
            // bar2 = col2, light blue
            g.selectAll(".bar2")
                .data(this.dataset)
                .enter().append("rect")
                .attr("class", classes.bar2)
                .attr("x", 0)
                .attr("y", d => y(d.name) + this.dims.bar2.spacing/2)
                .attr("width", d => x(d.col2))
                .attr("height", y.bandwidth() - this.dims.bar2.spacing)
        }

        // listener on top of bars, without zindex
        g.selectAll(".listener")
            .data(this.dataset)
            .enter().append("rect")
            .attr("class", classes.listener)
            .attr("x", -this.dims.paint.margin.left) // ignore the margin, all the way left
            .attr("y", d => yListener(d.name) - this.dims.paint.margin.top)
            .attr("width", this.dims.chart.width)
            .attr("height", yListener.bandwidth()) // NEXT: this is correct, continue here
            .on('mouseenter', (d,i) => {
                this.handleListenerMouseEnter(d,i)
            })
            .on('mouseleave', (d,i) => {
                this.handleListenerMouseExit(d,i)
            })
        
    }

    handleListenerMouseEnter = (d, i) => {
        log.trace("handleListenerMouseEnter(): d =", d)
        log.trace("handleListenerMouseEnter(): i =", i)

        // change the names from external tooltip root

//        const externalTooltip = true
//        const externalTooltipID = "externalTooltip"

        const { externalTooltip, externalTooltipID, externalTooltipRootID } = this.props
        
        let tooltip
        if(externalTooltip === true) {
            tooltip = d3.select(`#${externalTooltipID}`) // the tooltip for this canvas
            tooltip.style("display", "block")
        } else {
            tooltip = d3.select(this.refs.chartDiv).select("#tooltip") // the tooltip for this canvas
            tooltip.style("display", "block")
        }

        tooltip.select("#name").text(d.name)
        tooltip.select("#col1").text(`feedback: ${d.col1}`)
        const statesString = d.subset.map((ds, i) => `${ds.user.geo.state.code}`)
              .reduce((str, n) => {
                  if(!str)
                      return `${n}`
                  else
                      return str.includes(n) ? `${str}` : `${str},${n}`
              },'')
        tooltip.select("#states").text(`states: ${statesString}`)

        const uscdsString = d.subset.map((ds, i) => `${ds.user.geo.state.code}-${ds.user.geo.uscd.code}`)
        tooltip.select("#uscds").text(`uscds: ${uscdsString}`)

        
        if(externalTooltip === true) {
            // set x,w
            const x = d3.scaleLinear().rangeRound([0, this.dims.paint.width]);
            const y = d3.scaleBand().rangeRound([0,this.dims.paint.height]).padding(this.dims.paint.margin.inner)
            const yListener = d3.scaleBand().rangeRound([0,this.dims.chart.height])

            if(this.superset) {
                x.domain([0, d3.max(this.superset, d => {
                    return d.col1;
                })])
            } else {
                x.domain([0, d3.max(this.dataset, d => {
                    return d.col1;
                })])
            }
            
            y.domain(this.dataset.map( d => {
                log.trace("DashBarChar: handleListenerMouseEnter: f2(): d.name =", d.name)
                return d.name;
            }))

            yListener.domain(this.dataset.map( d => {
                return d.name;
            }))


            //    const ty = y(d.name) + tooltip.node().getBoundingClientRect().width / 2
            const corrY = tooltip.node().getBoundingClientRect().height
            const corrX = tooltip.node().getBoundingClientRect().width

            const chart = d3.select(this.refs.chartDiv)
            const chartX = chart.node().getBoundingClientRect().x
            const chartY = chart.node().getBoundingClientRect().y
            
            log.trace("handleListenerMouseEnter(): chartX =", chartX)
            log.trace("handleListenerMouseEnter(): chartY =", chartY)

            // do the claculations with external tip root id

            const externalRoot = d3.select(`#${externalTooltipRootID}`)
            const externalRootX = externalRoot.node().getBoundingClientRect().x
            const externalRootY = externalRoot.node().getBoundingClientRect().y
            log.trace("handleListenerMouseEnter(): externalRootX =", externalRootX)
            log.trace("handleListenerMouseEnter(): externalRootY =", externalRootY)

            const rootYCorr = chartY - externalRootY
            const rootXCorr = chartX
            
            log.trace("handleListenerMouseEnter(): corrY =", corrY)
            log.trace("handleListenerMouseEnter(): corrX =", corrX)
            const tx = x(d.col1) - corrX/2 + this.dims.paint.margin.left - 5 + rootXCorr // pixels inside
            const ty = y(d.name) - corrY + y.bandwidth()/2 - this.dims.bar1.spacing/2 + rootYCorr

            // don't do transition the first time, where the tooltip is outside of the root
            log.trace("handleListenerMouseEnter(): first: x =", tooltip.node().getBoundingClientRect().x)
            log.trace("handleListenerMouseEnter(): first: chartX =", chartX)

            const { classes } = this.props
            
            if(tooltip.node().getBoundingClientRect().x < chartX) {
                log.trace("handleListenerMouseEnter(): first: setting first transition")
                // tooltip.style("transition", "sdf")
                tooltip.classed(classes.killTransition, true)
            } else {
                tooltip.classed(classes.killTransition, false)
            }
            
            tooltip.style("transform", `translate(${tx}px,${ty}px)`)
            
        } else {
            // set x,w
            const x = d3.scaleLinear().rangeRound([0, this.dims.paint.width]);
            const y = d3.scaleBand().rangeRound([0,this.dims.paint.height]).padding(this.dims.paint.margin.inner)
            const yListener = d3.scaleBand().rangeRound([0,this.dims.chart.height])

            if(this.superset) {
                x.domain([0, d3.max(this.superset, d => {
                    return d.col1;
                })])
            } else {
                x.domain([0, d3.max(this.dataset, d => {
                    return d.col1;
                })])
            }
            
            y.domain(this.dataset.map( d => {
                log.trace("DashBarChar: handleListenerMouseEnter: f2(): d.name =", d.name)
                return d.name;
            }))

            yListener.domain(this.dataset.map( d => {
                return d.name;
            }))


            //        const ty = y(d.name) + tooltip.node().getBoundingClientRect().width / 2
            const ycorr = tooltip.node().getBoundingClientRect().height
            const xcorr = tooltip.node().getBoundingClientRect().width
            log.trace("DashBarChar: handleListenerMouseEnter: ycorr =", ycorr)
            log.trace("DashBarChar: handleListenerMouseEnter: xcorr =", xcorr)
            const tx = x(d.col1) - xcorr/2 + this.dims.paint.margin.left - 5 // pixels inside
            const ty = y(d.name) - ycorr + y.bandwidth()/2 - this.dims.bar1.spacing/2
            tooltip.style("transform", `translate(${tx}px,${ty}px)`)
        }
    }

    handleListenerMouseExit = (data, index) => {
        log.trace("DashBarChar: handleListenerMouseExit(): data =", data)
        log.trace("DashBarChar: handleListenerMouseExit(): index =", index)

        const { externalTooltip, externalTooltipID } = this.props

        
        if(externalTooltip === true) {
            const tooltip = d3.select(`#${externalTooltipID}`) // the tooltip for this canvas
            tooltip.style("display", "none")
        } else {
            const tooltip = d3.select(this.refs.chartDiv).select("#tooltip") // the tooltip for this canvas
            tooltip.style("display", "none")
        }
    }


    componentDidUpdate(prevProps) {
        log.trace("componentDidUpdate(): prevProps.dataset =", prevProps.dataset)
        log.trace("componentDidUpdate(): this.props.dataset =", this.props.dataset)
        if(!_.isEqual(this.props.dataset, prevProps.dataset)) {
            log.trace("componentDidUpdate(): NEW DATASET")
            this.superset = this.props.superset
            this.dataset = this.props.dataset
            this.drawChart()
        }
    }


    componentDidMount() {
        log.trace("componentDidMount(): this.dataset =", this.dataset)
        log.trace("componentDidMount(): this.dataset.length =", this.dataset.length)
        
        // TODO: see what's really going on here
        if(this.dataset && this.dataset[0] && this.dataset.length > 0)
            this.drawChart()
    }
    
    render() {

        const { classes } = this.props

	return (
            <div ref="chartDiv" id="chartDiv" className={classes.chartDiv} onClick={this.handleChartClick}>
              <div id="tooltip" className={classes.tooltip}>
                <div id="name">name</div>
                <div id="col1">count</div>
                <div id="states">states</div>
                <div id="uscds">uscds</div>
                <div className={classes.tooltipAnchor}></div>
              </div>
              <svg ref="chartSvg" id="chartSvg" className={classes.chartSvg}/>
            </div>
	)
    }

}

DashBarChart.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withStyles(styles, {name: "DashBarChart"})(DashBarChart)
